<div class='action-container'>
  <div class='action' (click)='click()'>
    <i [class]=icon></i>
  </div>
  @if(label){
    <div class='label'>{{label | translate}}</div>
  }
</div>
